import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

function BoutiqueText({ text, isFirst }) {
  const navigate = useNavigate();
  const Element = isFirst ? "h1" : "div";

  const handleClick = () => {
    const lowerText = text.toLowerCase();

    if (lowerText === "yak") {
      navigate("/yak");
    } else if (lowerText === "boutique") {
      navigate("/category/all");
    } else if (lowerText === "we are bodios") {
      navigate("/bodios");
    }
  };

  return (
    <motion.div
      initial={{ x: 0 }}
      whileHover={{ x: -10 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="w-full flex justify-center"
      onClick={handleClick}
    >
      <Element
        className="max-md:max-w-full text-center cursor-pointer no-underline"
      >
        {text}
      </Element>
    </motion.div>
  );
}

export default BoutiqueText;
